import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { cloneDeep, set } from 'lodash';

import type { HotelIngredient } from '@apps/main/modules/recipe/ingredients';

import {
  DEFAULT_ACTIVITY_SELECTION_FILTERS,
  ActivitySelectionFilter,
} from '../../models';
import type {
  ActivitySelectionFilterPillData,
  ActivitySelectionFiltersForm,
  ActivitySelectionFilterUpdate,
} from '../../models';

import {
  getActiveFilters,
  getActivitySelectionFilterFromIngredient,
} from './activitySelectionFiltersStoreLogic';

export const useActivitySelectionFiltersStore = defineStore(
  'ActivitySelectionFiltersStore',
  () => {
    // State
    const form = ref<ActivitySelectionFiltersForm>(
      cloneDeep(DEFAULT_ACTIVITY_SELECTION_FILTERS)
    );

    // Actions
    function setFiltersValuesFromIngredient(
      hotelIngredient: HotelIngredient
    ): void {
      const filters = getActivitySelectionFilterFromIngredient(hotelIngredient);
      form.value = filters;
    }

    function updateFormValue(
      filterUpdate: ActivitySelectionFilterUpdate
    ): void {
      switch (filterUpdate.type) {
        case ActivitySelectionFilter.ActivityName: {
          set(form.value, filterUpdate.type, filterUpdate.value.trim());
          break;
        }
        default:
          set(form.value, filterUpdate.type, filterUpdate.value);
          break;
      }
    }

    function resetAllFiltersToDefault(): void {
      form.value = cloneDeep(DEFAULT_ACTIVITY_SELECTION_FILTERS);
    }

    // Getters
    const activeFilters = computed<ActivitySelectionFilterPillData[]>(() =>
      getActiveFilters(form.value)
    );

    return {
      // State
      form,

      // Actions
      setFiltersValuesFromIngredient,
      updateFormValue,
      resetAllFiltersToDefault,

      // Getters
      activeFilters,
    };
  }
);
